<script setup lang="ts">
import AppErrorBoundary from '@/@core/components/AppErrorBoundary.vue';
import { appError } from '@/appErrorState';
import { bootstrapApp } from '@/bootstrapApplication';
import { getCurrentInstance, onBeforeMount } from 'vue';
import type { App } from 'vue';
import { RouterView } from 'vue-router';

onBeforeMount(() => {
  const vueApp = getCurrentInstance()?.appContext.app as App | undefined;
  if (vueApp) void bootstrapApp(vueApp);
});
</script>

<template>
  <AppErrorBoundary :error="appError">
    <RouterView />
  </AppErrorBoundary>
</template>

<!-- eslint-disable-next-line vue/enforce-style-attribute -->
<style lang="scss">
:root {
  font-family: var(--custom-font-family, Raleway), sans-serif, ui-sans-serif;
  font-size: var(--custom-font-size);
  color-scheme: normal !important;
}
@media (forced-colors: active) {
  span[class^='i-material-symbols'] {
    background-color: ButtonText !important;
  }
  span[class*=' i-material-symbols'] {
    background-color: ButtonText !important;
  }
}
</style>
